import type { IGatewayPageContent } from "../containers/GatewayPageContainer/types";

type GatewayActionButtonRenderers = Pick<IGatewayPageContent, "renderActionButton" | "renderStickyActionButton">;

export function resolveGatewayHeaderActionButton({
    renderActionButton,
    renderStickyActionButton,
}: GatewayActionButtonRenderers): React.ReactNode {
    if (renderStickyActionButton && renderActionButton) {
        return renderActionButton();
    }

    if (renderStickyActionButton) {
        return renderStickyActionButton();
    }

    return renderActionButton?.() ?? null;
}

export function resolveGatewayFooterActionButton({
    renderActionButton,
    renderStickyActionButton,
}: GatewayActionButtonRenderers): React.ReactNode {
    if (renderStickyActionButton) {
        return renderStickyActionButton();
    }

    return renderActionButton?.() ?? null;
}
